<template>
    <span class="o-step-text step-text" v-html="stepText"/>
</template>

<script>
import { mapGetters } from 'vuex';

import hyphensWords from '../../../utils/mixins/hyphens-words'

export default {
    name: 'OStepText',
    mixins: [hyphensWords],
    props: {
        step: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getObject',
            'getCategoryById',
        ]),
        translatedStepParameters(){
            const translatedParameters = {};
            if(this.step.parameters)
                this.step.parameters.forEach(p => {
                    switch(p.type ){
                    case 'object':
                        if(p.name === 'zone'){
                            const cat = this.getCategoryById(p.value)
                            translatedParameters[p.name] = this.t(cat, 'name');
                        }
                        else{
                            const obj = this.getObject(p.value)
                            if(obj)
                                switch(obj.type){
                                case 'portal':
                                    if(obj.meta.portal_type === 'Doors')
                                        translatedParameters[p.name] =  this.t(obj,'name');
                                    else
                                        translatedParameters[p.name] =  this.$t(this.t(obj,'portal_type'));
                                    break;
                                case 'floor':
                                case 'tenant':
                                case 'service':
                                default:
                                    translatedParameters[p.name] =  this.t(obj, 'name');
                                    break
                                }
                        }

                        break;
                    case 'resource':
                        translatedParameters[p.name] =  this.$t(p.value);
                        break;
                    case 'string':
                    default:
                        translatedParameters[p.name] =  p.value
                    }
                });
            return translatedParameters
        },
        stepText() {
            return this.hyphensWords(this.$t(this.step.id, this.translatedStepParameters))
        }
    }
}
</script>

<style lang="scss">
@import "o-step-text";   
</style>